import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // 函数式重定向：保留原 query（否则字符串重定向会丢弃 brandIds/categoryId 等参数，
  // 导致从 /brand 选完品牌回首页时分类信息丢失、跳回推荐页）
  { path: '/', redirect: to => ({ path: '/home', query: to.query }) },
  { path: '/home', name: 'Home', component: () => import('../views/Home.vue'), meta: { title: '首页' } },
  { path: '/list', name: 'List', component: () => import('../views/List.vue'), meta: { title: '商品列表' } },
  { path: '/brand', name: 'Brand', component: () => import('../views/Brand.vue'), meta: { title: '选择品牌' } },
  { path: '/detail/:id', name: 'Detail', component: () => import('../views/Detail.vue'), meta: { title: '商品详情' } },
  { path: '/mine', name: 'Mine', component: () => import('../views/Mine.vue'), meta: { title: '我的' } },
  { path: '/collect', name: 'Collect', component: () => import('../views/Collect.vue'), meta: { title: '我的收藏' } },
  { path: '/login', name: 'Login', component: () => import('../views/Login.vue'), meta: { title: '登录' } }
]

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

router.afterEach((to) => {
  document.title = (to.meta && to.meta.title) || '辛丰奢侈品'
})

export default router
